import React, { useState } from "react";
import "./FAQ.css";

const faqs = [
  {
    question: "WHY TRAVEL WITH MYSTIQUE REALM?",
    answer:
      "We craft Bhutan journeys with trusted local partners, private guides, and thoughtfully paced itineraries. Expect curated stays, seamless logistics, and meaningful cultural access that goes beyond standard tours.",
  },
  {
    question: "DO YOU OFFER SHORT OR CUSTOM TRIPS?",
    answer:
      "Yes. We design short escapes, multi-day itineraries, and fully custom journeys based on your interests, pace, and travel dates.",
  },
  {
    question: "WHAT IS INCLUDED IN A PACKAGE?",
    answer:
      "Most packages include private transport, licensed guide, accommodations, daily breakfast, and scheduled experiences. Inclusions vary by package—your proposal will list everything clearly.",
  },
  {
    question: "CAN YOU ARRANGE PERMITS AND ENTRY REQUIREMENTS?",
    answer:
      "Yes. We handle Bhutan visa processing and travel permits. We will guide you on required documents and timelines once you confirm your dates.",
  },
  {
    question: "WHAT IS THE BEST TIME TO VISIT BHUTAN?",
    answer:
      "Spring (Mar–May) and autumn (Sep–Nov) are most popular for clear skies and festivals. Winter is crisp and quiet, and summer offers lush landscapes with fewer crowds.",
  },
  {
    question: "CAN I REQUEST LUXURY OR ADVENTURE FOCUSED TRAVEL?",
    answer:
      "Absolutely. We build luxury, cultural, trekking, and camping-focused trips. Tell us your preferences and we will tailor the experience.",
  },
  {
    question: "HOW DO I BOOK?",
    answer:
      "Share your travel dates, group size, and interests. We will send a tailored proposal and itinerary. Once confirmed, we take care of the rest.",
  },
];

const Question: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(0);

  const toggleFAQ = (index: number) => {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  return (
    <section className="faq-section">
      <h1>FAQ</h1>
      {faqs.map((faq, index) => (
        <div key={index} className="faq-item">
          <button
            className="faq-question"
            onClick={() => toggleFAQ(index)}
            aria-expanded={activeIndex === index ? true : false}
            aria-controls={`faq-answer-${index}`}
          >
            {faq.question}
            <span className="faq-toggle-icon">
              {activeIndex === index ? "−" : "+"}
            </span>
          </button>
          {activeIndex === index && (
            <div
              id={`faq-answer-${index}`}
              className="faq-answer"
              role="region"
              aria-labelledby={`faq-question-${index}`}
            >
              <p>{faq.answer}</p>
            </div>
          )}
        </div>
      ))}
    </section>
  );
};

export default Question;
